export default "__VITE_ASSET__d7f41930__"